import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductListComponent, ProductListGridDefinition } from './components/product-list';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { CoreUIGridModule } from '@gh/core-ui-grid';
import { BuilderSetupProductRoutingModule } from './builder-setup-product-routing.module';
import { BuilderSharedModule } from '@gh/builder-shared';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonInternalSharedModule } from '@gh/common-internal-shared';

@NgModule({
  imports: [
    CommonModule,
    CoreUIGridModule,
    BuilderSetupProductRoutingModule,
    BuilderSharedModule.forChild(),
    MatToolbarModule,
    MatTableModule,
    MatIconModule,
    MatDialogModule,
    CommonInternalSharedModule.forChild(),
  ],
  providers: [
    ProductListGridDefinition,
  ],
  declarations: [
    ProductListComponent,
    ProductDetailsComponent,
  ],
})
export class BuilderSetupProductModule {}

